export const alfaNumeric = /^[a-zA-Z0-9 ]+$/;
export const alfaNumericWithoutSpace = /^[a-zA-Z0-9]+$/;
export const alfaString = /^[a-zA-Z ]+$/;
export const onlyNumber = /^[0-9]+$/;
export const invRejex = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Z\d!@#$%^&*]{8,}$/
export const chequeNumberRE = /^\d{6}$/;
